import { BaseModel } from './base.model';

export class ProductModel extends BaseModel {
    code: string;
    name: string;
    measure_table_id: number;
    other_infos: { color?: string; [key: string]: any };

    static validate(m: ProductModel): boolean {
        return !!(m.code && m.code.trim() && m.name && m.name.trim());
    }

    constructor(m?: any) {
        super();
        this.code = m ? (m.code || '') : '';
        this.name = m ? (m.name || '') : '';
        this.measure_table_id = m ? (m.measure_table_id || null) : null;
        this.other_infos = m ? (m.other_infos || {}) : {};
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/product.model.ts